export const CURRENT_VERSION = '2.2.8';
export const CURRENT_BUILD_DATE = '2026-08-07';
